<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
      [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
      style="margin-right: 10px; cursor: pointer;"
    (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  @if (showEntityLoader) {
    <div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
  }

  @if (!showEntityLoader) {
    <div>
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
                <input type="text" class="form-control"
                  id="tax-year" name="tax-year" placeholder=""
                  [(ngModel)]="scenarioEntity.TAX_YEAR" readonly>
                </div>
                @if (scenarioEntity.TAX_YEAR_NOT_VALID && !scenarioEntity.TAX_YEAR) {
                  <small class="text-danger">Please provide To Tax Year </small>
                }
              </div>

              <!-- Show different fields based on mode -->
              @if (!isUpdateMode) {
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="scenario-type-code"><b>Scenario Type Code<sup>*</sup>:</b></label>
                    <select class="form-control" id="scenario-type-code" name="scenario-type-code"
                      [(ngModel)]="scenarioEntity.SCENARIO_TYPE_CODE" (ngModelChange)="onScenarioTypeCodeChange()">
                      <option value="">-- Select --</option>
                      @for (scenarioTypeCode of allscenarioTypeCode; track $index; let i = $index) {
                        <option
                        [value]="scenarioTypeCode.SCENARIO_TYPE_CODE">{{scenarioTypeCode.SCENARIO_TYPE_CODE}}</option>
                      }
                    </select>
                  </div>
                  @if (scenarioEntity.SCENARIO_TYPE_CODE_NOT_VALID && !scenarioEntity.SCENARIO_TYPE_CODE) {
                    <small class="text-danger">Please provide Scenario Type Code  </small>
                  }
                </div>
              }

              @if (isUpdateMode) {
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="scenario"><b>scenario<sup>*</sup>:</b></label>
                    <input type="text" class="form-control" id="scenario" name="scenario"
                      [(ngModel)]="scenarioEntity.SCENARIO" readonly>
                    </div>
                  </div>
                }

                @if (!isUpdateMode) {
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="scenario-desc"><b>Scenario Desc<sup>*</sup>:</b></label>
                      <select class="form-control" id="scenario-desc" name="scenario-desc"
                        [(ngModel)]="scenarioEntity.SCENARIO_DESC" (ngModelChange)="onPopulateGroupObjYear()">
                        <option value="">-- Select --</option>
                        @for (scenarioDesc of allscenarioDesc; track $index; let i = $index) {
                          <option
                          [value]="scenarioDesc.SCENARIO_VALUE">{{scenarioDesc.SCENARIO_DESC}}</option>
                        }
                      </select>
                    </div>
                    @if (scenarioEntity.SCENARIO_DESC_NOT_VALID && !scenarioEntity.SCENARIO_DESC) {
                      <small class="text-danger">Please provide Scenario Desc</small>
                    }
                  </div>
                }

                @if (isUpdateMode) {
                  <div class="col-md-4">
                    <label for="app-scenario"><b>App scenario<sup>*</sup>:</b></label>
                    <input type="text" class="form-control" id="app-scenario" name="app-scenario"
                      [(ngModel)]="scenarioEntity.APP_SCENARIO" readonly>
                    </div>
                  }
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group" style="max-height: 200px;">
                      <label for="config-value"><b>Client Id<sup>*</sup>:</b></label>
                      <input list="clientIdList" class="form-control"
                        id="config-value" name="config-value"
                        [(ngModel)]="scenarioEntity.CONFIG_VALUE"
                        placeholder="Select Client Id"
                        [readonly]="isUpdateMode"
                        required/>
                        <datalist id="clientIdList" >
                          @for (clientId of allClientId; track $index; let i = $index) {
                            <option
                            [value]="clientId.CONFIG_VALUE">{{clientId.CONFIG_VALUE}}</option>
                          }
                        </datalist>
                        @if (scenarioEntity.CONFIG_VALUE_NOT_VALID && !scenarioEntity.CONFIG_VALUE) {
                          <small class="text-danger"> Please provide Client Id</small>
                        }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="gok"><b>Group Object Year<sup>*</sup>:</b></label>
                        @if (!isUpdateMode) {
                          <select class="form-control" id="gok" name="gok"
                            [(ngModel)]="scenarioEntity.GROUP_OBJ_KEY" (ngModelChange)="onPopulateFilingLEID()">
                            <option value="">-- Select --</option>
                            @for (groupObjByYear of allGroupObjByYear; track groupObjByYear) {
                              <option
                              [value]="groupObjByYear.GROUP_OBJ_KEY">{{groupObjByYear.GROUP_OBJ_KEY}}</option>
                            }
                          </select>
                        }
                        @if (isUpdateMode) {
                          <input type="text" class="form-control"
                            id="gok" name="gok" placeholder=""
                            [(ngModel)]="scenarioEntity.GROUP_OBJ_KEY" readonly>
                        }

                        @if (scenarioEntity.GROUP_OBJ_KEY_NOT_VALID && !scenarioEntity.GROUP_OBJ_KEY) {
                          <small class="text-danger">
                            Please provide Group Object Year
                          </small>
                        }
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="gok-898"><b>Group Object 898 Year<sup></sup>:</b></label>
                        @if (!isUpdateMode) {
                          <select class="form-control" id="gok-898" name="gok-898"
                            [(ngModel)]="scenarioEntity.GROUP_OBJ_KEY_898">
                            <option value="">-- Select --</option>
                            @for (groupObjByYear898 of allGroupObjByYear898; track groupObjByYear898) {
                              <option
                              [value]="groupObjByYear898.GROUP_OBJ_KEY">{{groupObjByYear898.GROUP_OBJ_KEY}}</option>
                            }
                          </select>
                        }
                        @if (isUpdateMode) {
                          <input type="text" class="form-control"
                            id="gok-898" name="gok-898" placeholder=""
                            [(ngModel)]="scenarioEntity.GROUP_OBJ_KEY_898" readonly>
                        }

                        @if (scenarioEntity.GROUP_OBJ_KEY_898_NOT_VALID && !scenarioEntity.GROUP_OBJ_KEY_898) {
                          <small class="text-danger">
                            Please provide Group Object 898 Year
                          </small>
                        }
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="panel panel-default">
                <div class="panel-body">
                  <div class="row">
                    <!-- Show both inputs in a single row, each taking 1/3 of the width -->
                    @if (!isUpdateMode) {
                      <div class="col-md-4">
                        <div class="form-group" style="max-height: 200px;">
                          <label for="filling-entity-id"><b>Filing Entity ID<sup>*</sup>:</b></label>
                          <input list="legalEntityIdList" class="form-control"
                            id="filling-entity-id" name="filling-entity-id"
                            [(ngModel)]="scenarioEntity.PARENT_LE_ID"
                            placeholder="Select Entity" required/>
                            <datalist id="legalEntityIdList" >
                              @for (leid of allLeids; track $index; let i = $index) {
                                <option
                                [value]="leid.PARENT_LE_ID">{{leid.PARENT_LE_ID}}</option>
                              }
                            </datalist>
                            @if (scenarioEntity.PARENT_LE_ID_NOT_VALID && !scenarioEntity.PARENT_LE_ID) {
                              <small class="text-danger">Please provide Filing Legal Entity Id</small>
                            }
                          </div>
                        </div>
                      }
                      @if (isUpdateMode) {
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="filling-entity-id"><b>Filing Entity ID<sup>*</sup>:</b></label>
                            <input type="text" class="form-control"
                              id="filling-entity-id" name="filling-entity-id" placeholder=""
                              [(ngModel)]="scenarioEntity.FILING_LE_ID">
                            </div>
                          </div>
                        }
                        @if (!isUpdateMode) {
                          <div class="col-md-4">
                            <div class="form-group">
                              <label for="scenario-ec"><b>Scenario<sup>*</sup>:</b></label>
                              <select class="form-control" id="scenario-ec" name="scenario-ec"
                                [(ngModel)]="scenarioEntity.SCENARIO_EC" (ngModelChange)="onPopulateOwnershipType()">
                                <option value="1" selected>1</option>
                                <option value="12" >12</option>
                              </select>
                              @if (scenarioEntity.SCENARIO_EC_NOT_VALID && !scenarioEntity.SCENARIO_EC) {
                                <small class="text-danger">
                                  Please provide Scenario
                                </small>
                              }
                            </div>
                          </div>
                        }
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="OwnershipType"><b>Ownership Type<sup>*</sup>:</b></label>
                            <input class="form-control"
                              id="OwnershipType" name="OwnershipType"
                              [(ngModel)]="scenarioEntity.OWNERSHIP_TYPE"
                              placeholder="Select Ownership Type"
                              [readonly]="isUpdateMode"
                              required/>
                            </div>
                          </div>
                        </div>


                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="tax-begin-year"><b>Tax Year Begin<sup>*</sup>:</b></label>
                              <input type="date" class="form-control" id="tax-begin-year" name="tax-begin-year"
                                [(ngModel)]="scenarioEntity.TAX_YEAR_START_DATE"
                                (ngModelChange)="onPopulateTraditionStartDate()"
                                required/>
                                @if (scenarioEntity.TAX_YEAR_START_DATE_NOT_VALID && !scenarioEntity.TAX_YEAR_START_DATE) {
                                  <small class="text-danger">Please provide Tax Year Begin </small>
                                }
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="tax-end-date"><b>Tax Year End<sup>*</sup>:</b></label>
                                <input type="date" class="form-control" id="tax-end-date" name="tax-end-date"
                                  [(ngModel)]="scenarioEntity.TAX_YEAR_END_DATE"
                                  required/>
                                  @if (scenarioEntity.TAX_YEAR_END_DATE_NOT_VALID && !scenarioEntity.TAX_YEAR_END_DATE) {
                                    <small class="text-danger">Please provide Tax Year End </small>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="view-start-date"><b>IRS Form Tax Begin Date<sup></sup>:</b></label>
                                  <input type="date" class="form-control" id="irs-start-date" name="irs-start-date"
                                    [(ngModel)]="scenarioEntity.IRS_FORM_TY_BEGIN_DATE"
                                    required/>
                                    @if (scenarioEntity.IRS_FORM_TY_BEGIN_DATE_NOT_VALID && !scenarioEntity.IRS_FORM_TY_BEGIN_DATE) {
                                      <small class="text-danger">Please provide IRS Form Tax Begin Date </small>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="view-end-date"><b>IRS Form Tax End Date<sup></sup>:</b></label>
                                    <input type="date" class="form-control" id="irs-end-date" name="irs-end-date"
                                      [(ngModel)]="scenarioEntity.IRS_FORM_TY_END_DATE"
                                      required/>
                                      @if (scenarioEntity.IRS_FORM_TY_END_DATE_NOT_VALID && !scenarioEntity.IRS_FORM_TY_END_DATE) {
                                        <small class="text-danger">Please provide IRS Form Tax End Date </small>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="form-group">
                                      <label for="batch-start-date"><b>EC Batch Start Date<sup>*</sup>:</b></label>
                                      <input type="date" class="form-control" id="batch-start-date" name="batch-start-date"
                                        [(ngModel)]="scenarioEntity.BATCH_START_DATE"
                                        required/>
                                        @if (scenarioEntity.BATCH_START_DATE_NOT_VALID && !scenarioEntity.BATCH_START_DATE) {
                                          <small class="text-danger">Please provide EC Batch Start Date </small>
                                        }
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <label for="batch-end-date"><b>EC Batch End Date<sup></sup>:</b></label>
                                        <input type="date" class="form-control" id="batch-end-date" name="batch-end-date"
                                          [(ngModel)]="scenarioEntity.BATCH_END_DATE"
                                          required/>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label for="view-start-date"><b>GTW View Start Date<sup>*</sup>:</b></label>
                                          <input type="date" class="form-control" id="view-start-date" name="view-start-date"
                                            [(ngModel)]="scenarioEntity.VIEW_START_DATE"
                                            required/>
                                            @if (scenarioEntity.VIEW_START_DATE_NOT_VALID && !scenarioEntity.VIEW_START_DATE) {
                                              <small class="text-danger">Please provide GTW View Start Date</small>
                                            }
                                          </div>
                                        </div>
                                        <div class="col-md-6">
                                          <div class="form-group">
                                            <label for="view-end-date"><b>GTW View End Date<sup></sup>:</b></label>
                                            <input type="date" class="form-control" id="view-end-date" name="view-end-date"
                                              [(ngModel)]="scenarioEntity.VIEW_END_DATE"
                                              required/>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="row" >
                                          <div class="col-md-6">
                                            <div class="form-group">
                                              <label for="tradition-start-date"><b>Tradition Start Date(for 898 purpose)<sup>*</sup>:</b></label>
                                              <input type="date" class="form-control" id="tradition-start-date" name="tradition-start-date"
                                                [(ngModel)]="scenarioEntity.TRADITIONAL_START_DATE"
                                                required/>
                                                @if (scenarioEntity.TRADITIONAL_START_DATE_NOT_VALID && !scenarioEntity.TRADITIONAL_START_DATE) {
                                                  <small class="text-danger">Please provide Tradition Start Date </small>
                                                }
                                              </div>
                                            </div>

                                            <div class="col-md-6">
                                              <div class="form-group">
                                                <label for="taxYearBegin"><b>Comments<sup></sup>:</b></label>
                                                <textarea class="form-control" rows="3"
                                                  [(ngModel)]="scenarioEntity.COMMENTS"
                                                  id="returnPreparedBy" name="returnPreparedBy"
                                                  placeholder="Enter Return Prepared By"
                                                required="true"></textarea>
                                                @if (scenarioEntity.COMMENTS_NOT_VALID && !scenarioEntity.COMMENTS) {
                                                  <small class="text-danger">Please provide Reason for Override </small>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>

                                <div class="modal-footer">
                                  <button class="save-button" type="button" (click)="save()"
                                    [disabled]="crudLoading || isSavingUpdate || isSavingDelete">
                                    @if (crudLoading || isSavingUpdate) {
                                      <span><i class="fa fa-spinner fa-pulse"></i></span>
                                    }
                                    {{isUpdateMode ? 'Update' : 'Create'}}
                                  </button>
                                  <button class="reset-button" type="button" (click)="reset()">Reset</button>
                                  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
                                  @if (isUpdateMode) {
                                    <button class="delete-button" type="button" (click)="deleteScenario()"
                                      [disabled]="crudLoading || isSavingUpdate || isSavingDelete">
                                      Delete
                                      @if (isSavingDelete) {
                                        <span><i class="fa fa-spinner fa-pulse"></i></span>
                                      }
                                    </button>
                                  }
                                </div>
